import React from 'react';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import SelectionList from '../SelectionList';
import NavigationTabs from '../nav/NavigationTabs';
import { COLORS } from '../../styles/colors';
import ButtonContent from '../ButtonContent';
const MAX_WORKOUT_COUNT = 12;

const UNSELECT_WARNING_MESSAGE = `Are you sure you want to remove this workout from your partner portal?`;
const sortByAdded = (a, b) => {
	if (a.added > b.added) {
		return -1;
	}
	if (a.added < b.added) {
		return 1;
	}
	return 0;
};

class PartnersForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			dataLoaded: false,
			selectedItems: {},
		};
	}
	componentDidMount() {
		const { fetch } = this.props;
		fetch().then(() => {
			let partner = this.props.assignments.partner;
			let workouts = this.props.workouts;
			let selected = {};
			if (partner && partner.workoutIds) {
				if (partner.workoutIds.length) {
					const partnerWorkouts = partner.workouts;
					partnerWorkouts.map((partnerWorkout, index) => {
						let workout = partnerWorkout;
						selected[workout._id] = workout;
						return true;
					});
				}
			}
			this.setState({
				...this.state,
				dataLoaded: true,
				selectedItems: selected,
			});
		});
	}
	handleChange = field => event => {
		this.setState({
			...this.state,
			formData: {
				...this.state.formData,
				[field]: event.target.value,
			},
		});
	};

	submitForm() {
		const { selectedItems } = this.state;
		const { assignToPartners } = this.props;
		const ids = Object.values(selectedItems)
			.map(item => item.id)
			.toString();
		assignToPartners(ids).then(data => {});
	}

	render() {
		const { selectedItems, dataLoaded } = this.state;
		const { workouts, workoutCats, isLoadMoreWorkouts, resetWorkouts } = this.props;
		let isLoadMore =  isLoadMoreWorkouts;

		if (dataLoaded) {
			return (
				<div>
					<NavigationTabs
						title="Assign"
						subtitle="Coach Channel"
						description={
							<span>
								{/* Assign workouts to your partners. You can only assign up to 9
								workouts at a time to keep content fresh and interesting.
								Partners must inroll in Fitbanx to recieve your workouts. Share
								your unique partner link with your fanbase to get followers by
								clicking
								<Link to="/share"> here</Link>. */}
								{
									<span>
										Place workouts inside your Coach Channel so clients can quickly access your workout creativity. You can only assign up to 12 workouts at a time. <br></br>  
										Clients 
										can only access your Coach Channel if they join FITBANX through 
										your unique referral link. <Link to="/share"> CLICK HERE</Link> to share your unique referral link.   
									</span>
								}
							</span>
						}
						set="assign"
						activeRoute="/assign/partners"
					/>
					<div
						style={{
							marginTop: 25,
							display: 'flex',
							border: '1px solid ' + COLORS.grey,
						}}
					>
						<div
							style={{
								width: '50%',
								borderRight: '1px solid ' + COLORS.grey,
								paddingTop: 10,
								paddingBottom: 10,
							}}
						>
							<SelectionList
								addSelectedClass={true}
								items={Object.values(workouts)}
								selectedItems={selectedItems}
								updateSelectedItems={selected =>
									this.setState({ ...this.state, selectedItems: selected })
								}
								categories={Object.values(workoutCats)}
								categoryField="categoryId"
								creatorTabs={true}
								defaultTab={0}
								user={this.props.user}
								maxSelected={MAX_WORKOUT_COUNT}
								hideTabs={[1, 2]}
								unselectWarningMessage={UNSELECT_WARNING_MESSAGE}
								fetchMore = {this.props.fetchMore}
								resetListing = { resetWorkouts }
								isLoadMore = {isLoadMore}
								isClientForm = {true}
								isRemoveWidth = { true }
								itemType='workout'
								fetchClientNotes={this.props.fetchClientNotes}
							/>
						</div>

						<div style={{ width: '50%', paddingTop: 10, paddingBottom: 10 }}>
							<SelectionList
								items={Object.values(workouts)}
								selectedItems={selectedItems}
								updateSelectedItems={selected =>
									this.setState({ ...this.state, selectedItems: selected })
								}
								categories={Object.values(workoutCats)}
								categoryField="categoryId"
								creatorTabs={true}
								defaultTab={2}
								user={this.props.user}
								maxSelected={MAX_WORKOUT_COUNT}
								hideTabs={[0, 1]}
								hideFilters={true}
								unselectWarningMessage={UNSELECT_WARNING_MESSAGE}
								fetchMore = {this.props.fetchMore}
								resetListing = {  resetWorkouts }
								isLoadMore = {isLoadMore}
								isClientForm = {true}
								isRemoveWidth = { true }
								fetchClientNotes={this.props.fetchClientNotes}
							/>
							{Object.values(selectedItems).length ? (
								<Button
									style={{ margin: '10px auto', display: 'block' }}
									onClick={() => this.submitForm()}
									variant="contained"
									color="primary"
								>
									<ButtonContent text="Assign Now" icon="clipboard-check" />
								</Button>
							) : null}
						</div>
					</div>
				</div>
			);
		}
		return null;
	}
}

export default PartnersForm;



// WEBPACK FOOTER //
// ./src/components/assignments/PartnersForm.js